var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListView',{attrs:{"no-gutters":"","cols":"6","sm":"3","loading":_vm.cursor.loading,"items":_vm.cursor.items,"item-class":"dynamic-padding","empty-text":_vm.noContentLabel},on:{"bottom-reached":_vm.cursor.loadItems},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('ProductCard',{attrs:{"product":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }